import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';
import { ZENJOB_CONTACT_EMAIL } from '../constants';
import { ContactContentBlockView } from './ContactContentBlockView';
import { ContactContentInfoCard } from './ContactContentInfoCard';
import { ContactContentCard } from './styledComponents';

export const ContactZenjobContent = () => {
  return (
    <ContactContentCard sx={{ mt: 10 }}>
      <ContactContentInfoCard
        textArr={[
          getTrans('contactZenjobPage.infoCard.body1'),
          getTrans('contactZenjobPage.infoCard.body2')
        ]}
      />
      <ContactContentBlockView
        title={getTrans('contactZenjobPage.emailAddress.title')}
        textToCopy={ZENJOB_CONTACT_EMAIL}
      >
        <Text>{ZENJOB_CONTACT_EMAIL}</Text>
      </ContactContentBlockView>
      <ContactContentBlockView
        title={getTrans('contactZenjobPage.subject.title')}
        textToCopy={getTrans('contactZenjobPage.subject.body')}
      >
        <Text>{getTrans('contactZenjobPage.subject.body')}</Text>
      </ContactContentBlockView>
    </ContactContentCard>
  );
};
